import {post} from '../../request'

/**
 * 分类列表
 * @param data
 * @returns {Promise<*>}
 */
export function geCattCountIndex(data) {
    return post("admin/resource.category/index", data)
}

/**
 * 添加分类
 * @param data
 * @returns {Promise<*>}
 */
export function createCat(data) {
    return post("admin/resource.category/create", data)
}

/**
 * 修改分类
 * @param data
 * @returns {Promise<*>}
 */
export function editCat(data) {
    return post("admin/resource.category/edit", data)
}

/**
 * 删除分类
 * @param data
 * @returns {Promise<*>}
 */
export function deleteCat(data) {
    return post("admin/resource.category/delete", data)
}
